export default __webpack_public_path__ + "static/media/640_business01-nl-mobile.61d6cc90.png";